import React, { forwardRef } from "react";
//import {useRef} from "react";

export const Input = forwardRef(function Input({ type, ...props}, ref) {
    return (
        <input
            type={type}
            className="w-full px-4 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:border-blue-500 dark:bg-gray-800 dark:text-white dark:border-gray-700"
            
            {...props}
            ref={ref}
        />
    )
}
)
Input.displayName = "Input"
